export const MAGNIFIER_MAX_OPTIMAL_HEIGHT = 350;
export const MAGNIFIER_MIN_HEIGHT = 330;

export const SMALL_FRAMED_ZOOM = 0;
export const SMALL_FOLDED_ZOOM = 0.35;
export const MEDIUM_ZOOM = 0.44;
export const LARGE_ZOOM = 0.22;
